import _objectSpread from "@babel/runtime/helpers/objectSpread2";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["className", "currency", "price", "discount", "currencyColor", "priceColor", "discountColor"];
import cn from 'classnames';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var PriceSmall = function PriceSmall(_ref) {
  var _ref$className = _ref.className,
    className = _ref$className === void 0 ? '' : _ref$className,
    currency = _ref.currency,
    price = _ref.price,
    discount = _ref.discount,
    currencyColor = _ref.currencyColor,
    priceColor = _ref.priceColor,
    _ref$discountColor = _ref.discountColor,
    discountColor = _ref$discountColor === void 0 ? 'base-main' : _ref$discountColor,
    priceSmallProps = _objectWithoutProperties(_ref, _excluded);
  var defaultPriceColorClassNames = discount ? 'text-red-main' : 'text-base-main';
  return /*#__PURE__*/_jsxs("p", _objectSpread(_objectSpread({
    className: className
  }, priceSmallProps), {}, {
    children: [/*#__PURE__*/_jsx("span", {
      className: cn('font-currency-xs', currencyColor ? "text-".concat(currencyColor) : defaultPriceColorClassNames),
      children: currency
    }), /*#__PURE__*/_jsx("span", {
      className: cn('font-price-xs', priceColor ? "text-".concat(priceColor) : defaultPriceColorClassNames),
      children: price
    }), discount && /*#__PURE__*/_jsx("span", {
      className: cn('font-discount-xs', discountColor ? "text-".concat(discountColor) : 'text-base-main'),
      children: discount
    })]
  }));
};
export default PriceSmall;